<template>
  <div>
    <div ref="echart" style="width:500px;height:400px;" class="echart" />
    <div>{{ data.historyShare }}</div>
    <div>{{ data.lastTimeShare }}</div>
    <div>{{ data.totalShareOrder }}</div>
  </div>
</template>

<script>

var echarts = require('echarts')
export default {
  props: ['data'],
  data: function () {
    return {

    }
  },

  methods: {
    getOption (dbData) {
      let dDate = []
      let series = []
      let abscissa = []
      for (let tmp of dbData.y_axis_1.data) {
        dDate.push(tmp.name)
        tmp.animation = false
        tmp.symbol = ['arrow', 'arrow']
        tmp.type = 'line'
        let tmpData = []
        for (let j of tmp.data) {
          tmpData.push(j)
        }
        tmp.data = tmpData
        if (tmp.name === '上证指数') {
          tmp.itemStyle = {
            color: '#888'
          }

          tmp.lineStyle = {
            type: 'dashed'
          }
        }
        series.push(tmp)
      }

      for (let k of dbData.abscissa) {
        abscissa.push(k)
      }

      for (let tmp of dbData.y_axis_2.data) {
        dDate.push(tmp.name)
        tmp.animation = false
        tmp.symbol = ['arrow', 'arrow']
        tmp.type = 'line'
        tmp.yAxisIndex = 1
        series.push(tmp)
      }

      let option = {

        // backgroundColor: '#000',
        title: {
          text: dbData.title,
          left: 'center',
          textAlign: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          show: true,
          left: '12%'
        },
        legend: {
          top: '10%',
          data: dDate
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: abscissa,
            axisLabel: {
              // rotate: '45',
            }
          }
        ],
        yAxis: [
          {
            splitLine: {
              show: false
            },
            type: 'value',
            name: dbData.y_axis_1.name,
            position: 'left',
            min: function (value) { return Math.max(parseInt(value.min - 1000), 0) }
          },
          {
            splitLine: {
              show: false
            },
            type: 'value',
            name: dbData.y_axis_2.name,
            position: 'right'
            // ,
            // min:
            //   function (value) {return Math.max(parseInt(value.min - 1000), 0)},
          }
        ],
        series: series
      }
      console.debug(option)
      return option
    }
  },
  components: {

  },
  watch: {

  },
  mounted () {
    if (this.data.imageJson) {
      let option = this.getOption(this.data.imageJson)
      this.$nextTick(function () {
        echarts.init(this.$refs.echart).setOption(option)
      })
    }
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/chart/yty_model/historyOfShareOutBonus.vue